// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfp_a bik_bk bik_bl bik_bo","SwipeLeftToClose--animating":"bfp_b"};